import { useTranslation } from 'next-i18next';
import React from 'react';

const ErrorPage = ({ error, logger }) => {
    const { t: tCommon } = useTranslation('', { keyPrefix: '$common' });
    /* eslint-disable no-console */
    console.log(`Error in ErrorPage:  at ${new Date().toISOString()}`, error);
    logger(error, { type: 'error', sendLog: true });
    return (React.createElement("div", { className: "container pg404", id: "page-404" },
        React.createElement("div", { className: "tagline-wrap" },
            React.createElement("section", null,
                React.createElement("h1", null, tCommon('tips404_1')),
                React.createElement("section", null,
                    React.createElement("h3", null, tCommon('tips404_2')),
                    React.createElement("p", null,
                        "- ",
                        tCommon('tips404_3')),
                    React.createElement("p", null,
                        "- ",
                        tCommon('tips404_4')))))));
};

export { ErrorPage as E };
//# sourceMappingURL=ErrorPage-hsjsOFEm.js.map
